import React, { useState, useEffect, useRef } from 'react'
import { Form, Input, Switch, Space } from 'antd'

interface CommonEditWithSwitchComponentProps {
  value?: any
  onChange?: (value: any) => void
  productCode?: string
  disabled?: boolean
  label?: string
}

const CommonEditWithSwitchComponent: React.FC<CommonEditWithSwitchComponentProps> = ({
  value,
  onChange,
  productCode = '',
  disabled = false
}) => {
  const [useDifferentCode, setUseDifferentCode] = useState(false)
  const initializedRef = useRef(false)
  const lastProductCodeRef = useRef(productCode)

  useEffect(() => {
    if (!initializedRef.current) {
      // 只在第一次渲染时，根据 value 和 productCode 是否不同来设置开关状态
      const isDifferent = value && value !== productCode
      setUseDifferentCode(isDifferent)
      initializedRef.current = true
    } else if (!useDifferentCode) {
      // 开关关闭时，如果 Product Code 变化，同步更新 Cust Prod Code
      if (productCode !== lastProductCodeRef.current && value !== productCode) {
        onChange && onChange(productCode)
      }
    }

    // 更新 lastProductCodeRef
    lastProductCodeRef.current = productCode
  }, [value, productCode, useDifferentCode])

  const handleSwitchChange = (checked: boolean) => {
    setUseDifferentCode(checked)
    if (!checked) {
      // 关闭开关时，同步 Cust Prod Code 为 Product Code
      onChange && onChange(productCode)
    }
  }

  const handleInputChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    const newValue = e.target.value
    onChange && onChange(newValue)
  }

  // 计算输入框应该显示的值
  const displayValue = useDifferentCode ? (value || '') : productCode

  return (
    <div style={{ width: '100%' }}>
      <div style={{ marginBottom: '8px', display: 'flex', alignItems: 'center', gap: '8px' }}>
        <span style={{ fontSize: '14px', color: '#666' }}>
          {useDifferentCode ? 'Cust Prod Code Use different code:' : 'Cust Prod Code Same as product code'}
        </span>
        <Switch
          checked={useDifferentCode}
          onChange={handleSwitchChange}
          disabled={disabled}
          checkedChildren="Different"
          unCheckedChildren="Same"
        />
      </div>
      <Input
        value={displayValue}
        onChange={handleInputChange}
        disabled={disabled || !useDifferentCode}
        placeholder={!useDifferentCode ? '(Same as Product Code)' : 'Enter customer code'}
        style={{
          width: '100%',
          color: !useDifferentCode ? '#999' : '#inherit',
          fontStyle: !useDifferentCode ? 'italic' : 'normal'
        }}
      />
    </div>
  )
}

export default CommonEditWithSwitchComponent
